import React, { useState, useEffect } from 'react';
import { fetchSales } from '../../services/api';
import './SaleBillLubeGST.css';

export default function SaleBillLubeGST({ user }) {
  const companyId = user?.Companyid || user?.company_id || "1";
  const [selectedBill, setSelectedBill] = useState(null);
  const [bills, setBills] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadBills();
  }, [companyId]);

  const loadBills = async () => {
    setLoading(true);
    try {
      const res = await fetchSales({ 
        Companyid: companyId,
        FromDate: "01-01-2024",
        ToDate: formatDateForAPI(new Date()) 
      });
      if (res.success) {
        const raw = res.Response || [];
        const list = Array.isArray(raw) ? raw : [raw];
        // Filter for lubes (non-fuel)
        const lubeList = list.filter(r => 
          !['HSD', 'MS', 'CNG', 'DIESEL', 'PETROL'].includes((r.Product || r.product || '').toUpperCase())
        ).map(r => ({
          id: r.IDS || r.Recid || r.Saleid,
          date: r.Date1 || r.date,
          billNo: r.BillNo || r.billNo || `LB-${r.IDS}`,
          customer: r.Customer || r.customer || 'Cash',
          product: r.Product || r.product,
          qty: parseFloat(r.Qty || r.qty || 0),
          rate: parseFloat(r.Rate || r.rate || 0),
          taxPer: parseFloat(r.TaxPer || r.taxPer || 18),
          tax: parseFloat(r.Tax || r.tax || 0),
          amount: parseFloat(r.Amount || r.amount || 0)
        }));
        setBills(lubeList);
      }
    } catch (err) {
      console.error("Lube bills fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  function formatDateForAPI(d) {
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    let year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [day, month, year].join('-');
  }

  const bill = bills.find(b => b.id === selectedBill);
  const cgst = bill ? (bill.tax / 2).toFixed(2) : 0;
  const sgst = bill ? (bill.tax / 2).toFixed(2) : 0;

  return (
    <div className="sale-bill-page">
      <div className="page-header">
        <h2 className="page-title">Sale Bill (Lube-GST)</h2>
        <div style={{display:'flex',gap:8}}>
          {selectedBill && <button className="btn btn-success btn-sm" onClick={() => window.print()}>🖨️ Print</button>}
          <button className="export-btn">⬆ Export</button>
        </div>
      </div>

      <div className="section-card">
        <div className="section-header">Select Bill to View / Print</div>
        <div className="table-wrapper">
          <table className="data-table">
            <thead>
              <tr>
                <th className="text-left">Date</th>
                <th className="text-left">Bill No</th>
                <th className="text-left">Customer</th>
                <th className="text-left">Product</th>
                <th className="text-right">Qty</th>
                <th className="text-right">Amount (₹)</th>
                <th className="text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {bills.map((b, i) => (
                <tr key={b.id} className={selectedBill === b.id ? 'selected-row' : ''}>
                  
                  <td className="text-left">{b.date}</td>
                  <td className="text-left" style={{fontWeight:700, color:'var(--primary)', fontFamily:'monospace'}}>{b.billNo}</td>
                  <td className="text-left">{b.customer}</td>
                  <td className="text-left">{b.product}</td>
                  <td className="text-right">{b.qty}</td>
                  <td className="text-right">₹{b.amount.toFixed(2)}</td>
                  <td className="text-center">
                    <button className="btn btn-sm btn-info" onClick={() => setSelectedBill(b.id)}>
                      <i className="bi bi-eye me-1"></i> View Bill
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {bill && (
        <div className="gst-invoice">
          <div className="invoice-header">
            <div className="invoice-company">
              <h2>DKR ALIVELAMMA FILLING STATION</h2>
              <p>NH-65, Kurnool Road, Uppal, Hyderabad - 500039</p>
              <p>GSTIN: 36DKRAL1234A1Z5 | Phone: +91 98765 43210</p>
            </div>
            <div className="invoice-title">
              <div>TAX INVOICE</div>
              <div className="invoice-no">{bill.billNo}</div>
              <div className="invoice-date">{bill.date}</div>
            </div>
          </div>

          <div className="invoice-body">
            <div className="invoice-party">
              <strong>Bill To:</strong> {bill.customer || 'Cash Customer'}
            </div>
            <table className="invoice-table">
              <thead><tr>
                <th>#</th><th>Description</th><th>HSN</th><th>Qty</th><th>Rate</th><th>Taxable Amt</th><th>CGST</th><th>SGST</th><th>Total</th>
              </tr></thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>{bill.product}</td>
                  <td>27101991</td>
                  <td>{bill.qty} Ltr</td>
                  <td>₹{bill.rate.toFixed(2)}</td>
                  <td>₹{(bill.qty * bill.rate).toFixed(2)}</td>
                  <td>₹{cgst} ({bill.taxPer / 2}%)</td>
                  <td>₹{sgst} ({bill.taxPer / 2}%)</td>
                  <td>₹{bill.amount.toFixed(2)}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan="5" style={{textAlign:'right', fontWeight:700}}>Total</td>
                  <td>₹{(bill.qty * bill.rate).toFixed(2)}</td>
                  <td>₹{cgst}</td>
                  <td>₹{sgst}</td>
                  <td>₹{bill.amount.toFixed(2)}</td>
                </tr>
              </tfoot>
            </table>
            <div className="invoice-footer">
              <div>Amount in Words: <strong>Rupees {amtToWords(bill.amount)} Only</strong></div>
              <div className="invoice-sign">Authorised Signatory</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function amtToWords(n) {
  const ones = ['','One','Two','Three','Four','Five','Six','Seven','Eight','Nine','Ten','Eleven','Twelve','Thirteen','Fourteen','Fifteen','Sixteen','Seventeen','Eighteen','Nineteen'];
  const tens = ['','','Twenty','Thirty','Forty','Fifty','Sixty','Seventy','Eighty','Ninety'];
  const num = Math.floor(n);
  if (num < 20) return ones[num];
  if (num < 100) return tens[Math.floor(num/10)] + (num % 10 ? ' ' + ones[num % 10] : '');
  if (num < 1000) return ones[Math.floor(num/100)] + ' Hundred' + (num % 100 ? ' ' + amtToWords(num % 100) : '');
  if (num < 100000) return amtToWords(Math.floor(num/1000)) + ' Thousand' + (num % 1000 ? ' ' + amtToWords(num % 1000) : '');
  return amtToWords(Math.floor(num/100000)) + ' Lakh' + (num % 100000 ? ' ' + amtToWords(num % 100000) : '');
}
